var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPetCadastrado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 38,
    viewBox: "0 0 47 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.466 2.91538C21.0353 0.214557 25.9647 0.214557 29.534 2.91538L45.9944 15.3705C46.5476 15.7891 46.6518 16.5793 46.2259 17.127C45.8077 17.6649 45.0346 17.7665 44.4915 17.3548L40.6766 14.4628V27.3496C40.6766 32.8725 36.1994 37.3496 30.6766 37.3496H16.3234C10.8006 37.3496 6.32343 32.8725 6.32343 27.3496V14.4653L2.50855 17.3553C1.96542 17.7667 1.19242 17.665 0.774181 17.1271C0.348267 16.5793 0.452448 15.7891 1.00577 15.3704L17.466 2.91538ZM14.9215 18.6752C14.9215 20.3331 15.8041 22.1 17.5692 23.9761C19.3343 25.8504 21.3112 27.7975 23.5 29.8174C25.7526 27.7975 27.7614 25.8513 29.5265 23.9785C31.2916 22.1058 32.1742 20.3422 32.1742 18.6876C32.1742 17.3157 31.7079 16.1727 30.7755 15.2587C29.8431 14.3463 28.7249 13.8901 27.4212 13.8901C26.613 13.8901 25.8794 14.0595 25.2201 14.3984C24.5609 14.7372 23.9875 15.1628 23.5 15.6752C23.0747 15.1628 22.5201 14.7372 21.8363 14.3984C21.1525 14.0595 20.4368 13.8901 19.6893 13.8901C18.3806 13.8901 17.2584 14.3447 16.3226 15.2537C15.3869 16.1628 14.9199 17.3033 14.9215 18.6752Z",
    fill: "#5AB2AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetCadastrado);
export default __webpack_public_path__ + "static/media/petCadastrado.3350fa9befc8fa858dd87579c56b0c93.svg";
export { ForwardRef as ReactComponent };